import React from 'react';
import Paragraph from '../Paragraph/Paragraph';
import profile from "../../image/profile.png"
export const NavBar = () => {
           return (
                      <div className="p-4" >
                                 <div className="w-[100%] h-[80px] bg-[#444] border-[4px] border-[#444] shadow-2xl shadow-[#000] rounded-[24px] mt-4 flex flex-row justify-between">

                                            <Paragraph
                                                       className=" text-[32px] text-[#E83A59] pt-4  ml-6 "
                                                       paragraphText="Color Picker :)"
                                            />

                                            <img src={profile} alt="profile" className='rounded-[50px] m-2 bg-[#67E6DC] shadow-2xl shadow-[#000] border-[2px] border-[#AE1438]' />


                                 </div>
                      </div>
           );
};
